import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

const Notary = ({ button, src, description, name, biography, alt }) => {
  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => setShowModal(false);
  const handleShowModal = () => setShowModal(true);

  return (
    <div className='notary'>
      <Card>
        <Card.Img variant='top' src={src} alt={alt} />
        <Card.Body>
          <Card.Text>{description}</Card.Text>
          <Card.Title>{name}</Card.Title>
          {name == 'Mark Lindenmaier' ? (
            <p className='info-lindenmaier'>
              Das Amt von Herrn Lindenmaier wird derzeit von Herrn Notarassessor Maximilian Schilling verwaltet. Sie
              erreichen Herrn Schilling telefonisch über die Kanzlei und per Mail unter
              notariatsverwaltung@ll-notare.de.
            </p>
          ) : null}
          <Button type='button' onClick={handleShowModal} variant={button.variant}>
            {button.text}
          </Button>
        </Card.Body>
      </Card>

      <Modal className='modal-notaries' show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton closeLabel="Dialog schließen">
          <Modal.Title as='h2'>Biografie {name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {Object.values(biography).map((b) => {
            return (
              <div key={b.year}>
                <h3 className='title'>{b.year}</h3>
                <p className='text'>{b.text}</p>
              </div>
            );
          })}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='outline-primary' onClick={handleCloseModal}>
            Schließen
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

Notary.propTypes = {
  button: PropTypes.object,
  src: PropTypes.string,
  description: PropTypes.string,
  name: PropTypes.string,
  biography: PropTypes.object,
  alt: PropTypes.string,
};

export default Notary;
